import { useState, useEffect, useCallback, useRef } from "react";

const useTooltipPosition = () => {
    const wrapperRef = useRef(null);
    const tooltipRef = useRef(null);
    const [position, setPosition] = useState("top");

    const updatePosition = useCallback(() => {
        const wrapper = wrapperRef.current;
        const tooltip = tooltipRef.current;
        if (!wrapper || !tooltip) return;
        const anchorRect = wrapper.getBoundingClientRect();
        const tooltipHeight = tooltip.offsetHeight || 0;
        const margin = 5;
        const spaceAbove = anchorRect.top;
        const spaceBelow = window.innerHeight - anchorRect.bottom;
        if (spaceAbove < tooltipHeight + margin && spaceBelow > spaceAbove) setPosition("bottom");
        else setPosition("top");
    }, []);

    useEffect(() => {
        updatePosition();
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition, true);
        return () => {
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition, true);
        };
    }, [updatePosition]);

    return {
        wrapperRef,
        tooltipRef,
        position,
        updatePosition, // in case you want to trigger it manually
    };
};

export default useTooltipPosition;
